import React from "react";
import AppShell from "./components/AppShell"; // Adjust the import path based on your file structure
import { ThemeProvider } from "./theme/ThemeProvider";
function App() {
  return (
    <ThemeProvider>
      <AppShell />
    </ThemeProvider>
  );
}

export default App;
